/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import ElementUI from "element-ui";
// import 'element-ui/lib/theme-chalk/index.css';
import "../sass/element-variables.scss";
import locale from "element-ui/lib/locale/lang/es";
import auth from "./auth.js";
import _ from "underscore";

import Vue from "vue";
import store from "./store";
import VueDragDrop from "vue-drag-drop";
// import vuetify from "./vuetify";

Vue.use(ElementUI, { locale });
Vue.use(auth);
Vue.use(VueDragDrop);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import notfound from "./components/notfound.vue";
import login from "./components/login.vue";
import dashboard from "./components/dashboard.vue";

import overtime_approval from "./components/overtime-approval.vue";
import shift_assignment from "./components/shift-assignment/shift-assignment.vue";
import assign_bonuses from "./components/bonuses/assign-bonuses.vue";
// import scheduler from './components/scheduler/scheduler.vue';
import employees from "./components/employees/employees.vue";
import permissions from "./components/permissions.vue";
import tutorial from "./components/tutorial.vue";

//Reports
import check_in_out from "./components/reports/check-in-out.vue";
import absences from "./components/reports/absences.vue";
import absences_and_licences from "./components/reports/absences-and-licences.vue";
import shift_assignment_report from "./components/reports/shift-assignment-report.vue";
import feeding_report from "./components/reports/feeding-report.vue";
import hours_worked from "./components/reports/hours-worked.vue";
import hours_worked_daily from "./components/reports/hours-worked-daily.vue";
import hours_worked_one_row from "./components/reports/hours-worked-one-row.vue";
import general_report from "./components/reports/general-report.vue";
import overtime_report from "./components/reports/overtime-report.vue";
import late_check_in_early_check_out from "./components/reports/late-check-in-early-check-out.vue";
import functional_areas_status from "./components/reports/functional-areas-status.vue";
import daily_attendance_details from "./components/reports/daily-attendance-details.vue";
import bonuses_report from "./components/reports/bonuses.vue";
import global_headcount from "./components/reports/global-headcount.vue";
// import employees_status from './components/employees-status.vue';

// Config
import functional_areas from "./components/config/functional-areas.vue";
import excuses from "./components/config/excuses.vue";
import devices from "./components/config/devices.vue";
import holidays from "./components/config/holidays.vue";
import rosters from "./components/config/rosters.vue";
import shifts from "./components/config/shifts.vue";
import users from "./components/config/users.vue";
import roles_permissions from "./components/config/roles-permissions.vue";
import labor_agreements from "./components/config/labor-agreements.vue";
import cost_centers from "./components/config/cost-centers.vue";
import cutoff_settings from "./components/config/cutoff-settings.vue";
import alerts from "./components/config/alerts.vue";
import Swal from "sweetalert2";

import batch_processes from "./components/batch-processes.vue";

Vue.component("notfound", notfound);
Vue.component("login", login);
Vue.component("dashboard", dashboard);
Vue.component("app-header", require("./components/app-header.vue").default);
Vue.component("app-aside", require("./components/app-aside.vue").default);
Vue.component(
  "app-control-aside",
  require("./components/app-control-aside.vue").default
);
Vue.component("check-in-out", check_in_out);
Vue.component("absences", absences);
Vue.component("absences-and-licences", absences_and_licences);
Vue.component("shift-assignment-report", shift_assignment_report);
Vue.component("feeding-report", feeding_report);
Vue.component("hours-worked", hours_worked);
Vue.component("hours-worked-daily", hours_worked_daily);
Vue.component("hours-worked-one-row", hours_worked_one_row);
Vue.component("general-report", general_report);
Vue.component("overtime-report", overtime_report);
Vue.component("late-check-in-early-check-out", late_check_in_early_check_out);
Vue.component("functional-areas-status", functional_areas_status);
Vue.component("daily-attendance-details", daily_attendance_details);
Vue.component("global-headcount", global_headcount);
Vue.component("functional-areas", functional_areas);
Vue.component("employees", employees);
Vue.component("permissions", permissions);
Vue.component("tutorial", tutorial);
// Vue.component('employees-status', employees_status);
Vue.component("shift-assignment", shift_assignment);
Vue.component("assign-bonuses", assign_bonuses);
// Vue.component('scheduler', scheduler);
Vue.component("overtime-approval", overtime_approval);
Vue.component("excuses", excuses);
Vue.component("devices", devices);
Vue.component("holidays", holidays);
Vue.component("rosters", rosters);
Vue.component("shifts", shifts);
Vue.component("users", users);
Vue.component("roles-permissions", roles_permissions);
Vue.component("labor-agreements", labor_agreements);
Vue.component("cost-centers", cost_centers);
Vue.component("cutoff-settings", cutoff_settings);
Vue.component("alerts", alerts);
Vue.component("batch-processes", batch_processes);

const router = new VueRouter({
  routes: [
    {
      path: "",
      component: overtime_approval,
      meta: {
        title: "Aprobación de horas",
        requires: ["overtime.view", "overtime.approve", "overtime.comment"],
      },
    },
    { path: "/notfound", component: notfound },
    { path: "/login", component: login },
    { path: "/dashboard", component: dashboard, meta: { title: "Dashboard" } },
    {
      path: "/reports/checkinout",
      component: check_in_out,
      meta: {
        title: "Entradas y salidas",
        requires: ["reports.checkinout", "reports.checkinut"],
      },
    },
    {
      path: "/reports/absences",
      component: absences,
      meta: {
        title: "Ausencias / Llegadas tarde",
        requires: ["reports.absences"],
      },
    },
    {
      path: "/reports/absencesandlicences",
      component: absences_and_licences,
      meta: {
        title: "Licencias",
        requires: ["reports.absencesandlicences", "reports.absences"],
      },
    },
    {
      path: "/reports/shiftassignment",
      component: shift_assignment_report,
      meta: {
        title: "Reporte de asignación de turnos",
        requires: ["reports.shiftassignment"],
      },
    },
    {
      path: "/reports/feeding",
      component: feeding_report,
      meta: {
        title: "Alimentación",
        requires: ["reports.feeding"],
      },
    },
    {
      path: "/reports/hoursworked",
      component: hours_worked,
      meta: {
        title: "Liquidador de horas",
        requires: ["reports.hoursworked"],
      },
    },
    {
      path: "/reports/hoursworkeddaily",
      component: hours_worked_daily,
      meta: {
        title: "Horas trabajadas por día",
        requires: ["reports.hoursworkeddaily", "reports.hoursworked"],
      },
    },
    {
      path: "/reports/hoursworkedonerow",
      component: hours_worked_one_row,
      meta: {
        title: "Horas trabajadas por empleado",
        requires: ["reports.hoursworkedonerow", "reports.hoursworked"],
      },
    },
    {
      path: "/reports/generalreport",
      component: general_report,
      meta: {
        title: "Reporte General",
        requires: ["reports.generalreport", "reports.hoursworkedonerow", "reports.hoursworked"],
      },
    },
    {
      path: "/reports/overtimeauthorization",
      component: overtime_report,
      meta: {
        title: "Horas Extra",
        requires: ["reports.overtimeauthorization", "reports.overtime"],
      },
    },
    {
      path: "/reports/latecheckinearlycheckout",
      component: late_check_in_early_check_out,
      meta: {
        title: "Llegadas tarde / Salidas temprano",
        requires: ["reports.latecheckinearlycheckout"],
      },
    },
    {
      path: "/reports/functionalareastatus",
      component: functional_areas_status,
      meta: {
        title: "Estado de Áreas",
        requires: ["reports.functionalareastatus"],
      },
    },
    {
      path: "/reports/dailyattendancedetails",
      component: daily_attendance_details,
      meta: {
        title: "Detalle de asistencia",
        requires: ["reports.dailyattendancedetails"],
      },
    },
    {
      path: "/reports/bonuses",
      component: bonuses_report,
      meta: {
        title: "Histórico de Bonificaciones",
        requires: ["reports.bonuses"],
      },
    },
    {
      path: "/reports/globalheadcount",
      component: global_headcount,
      meta: {
        title: "Personal por Empresa (Global)",
      },
    },
    {
      path: "/functionalareas/:id?/:action?",
      component: functional_areas,
      meta: {
        title: "Áreas",
        requires: [
          "config.view_functionalareas",
          "config.crud_functionalareas",
        ],
      },
    },
    // {path: '/employees/status', component: employees_status, meta:{title: 'Supervisados'}},
    {
      path: "/shiftassignment",
      component: shift_assignment,
      meta: {
        title: "Asignación de turnos",
        requires: ["shifts.view", "shifts.assign"],
      },
    },
    {
      path: "/bonuses",
      component: assign_bonuses,
      meta: {
        title: "Asignar Bonificación",
        requires: ["bonuses.edit", "bonuses.assign"],
      },
    },
    // { path: '/scheduler', component: scheduler, meta: { title: 'Asignación de turnos', requires: ['shifts.view', 'shifts.assign'] } },
    {
      path: "/reports/attendancedetailsbyemployee",
      component: overtime_approval,
      meta: {
        title: "Aprobación de horas",
        requires: ["overtime.view", "overtime.approve"],
      },
    },
    {
      path: "/employees/:id?/:action?/:relId?/:relAction?",
      component: employees,
      meta: { title: "Empleados", requires: ["employees.view_all"] },
    },
    {
      path: "/tutorials",
      component: tutorial,
      meta: {
        title: "Tutoriales y Guía de Uso",
      },
    },
    {
      path: "/permissions/:id?/:action?",
      component: permissions,
      meta: {
        title: "Permisos",
        requires: ["permissions.view", "permissions.issue"],
      },
    },
    {
      path: "/excuses/:id?/:action?",
      component: excuses,
      meta: {
        title: "Tipos de permisos",
        requires: [
          "config.view_excuses",
          "config.crud_excuses",
        ],
      },
    },
    {
      path: "/devices/:id?/:action?",
      component: devices,
      meta: {
        title: "Dispositivos",
        requires: [
          "config.view_devices",
          "config.crud_devices",
        ],
      },
    },
    {
      path: "/holidays/:id?/:action?",
      component: holidays,
      meta: {
        title: "Días festivos",
        requires: [
          "config.view_holidays",
          "config.crud_holidays",
        ],
      },
    },
    {
      path: "/rosters/:id?/:action?",
      component: rosters,
      meta: {
        title: "Nóminas",
        requires: [
          "config.view_rosters",
          "config.crud_rosters",
        ],
      },
    },
    {
      path: "/shifts/:id?/:action?",
      component: shifts,
      meta: {
        title: "Turnos",
        requires: [
          "config.view_shifts",
          "config.crud_shifts",
        ],
      },
    },
    {
      path: "/users/:id?/:action?",
      component: users,
      meta: {
        title: "Usuarios",
        requires: [
          "config.view_users",
          "config.crud_users",
        ],
      },
    },
    {
      path: "/roles/:id?/:action?",
      component: roles_permissions,
      meta: {
        title: "Roles y Permisos",
        requires: [
          "config.view_roles",
          "config.crud_roles",
        ],
      },
    },
    {
      path: "/cutoff-dates",
      component: cutoff_settings,
      meta: {
        title: "Fechas de Corte General",
        requires: [
          "config.cutoff_dates",
          "config.view_all",
          "config.crud_all"
        ],
      },
    },
    {
      path: "/alerts",
      component: alerts,
      meta: {
        title: "Alertas y Notificaciones",
        requires: [
          "config.alerts",
        ],
      },
    },
    {
      path: "/laboragreements/:id?/:action?",
      component: labor_agreements,
      meta: {
        title: "Acuerdos laborales",
        requires: [
          "config.view_laboragreements",
          "config.crud_laboragreements",
        ],
      },
    },
    {
      path: "/costcenters/:id?/:action?",
      component: cost_centers,
      meta: {
        title: "Centros de Costo",
        requires: [
          "config.view_costcenters",
          "config.crud_costcenters",
        ],
      },
    },
    {
      path: "/batchprocesses/:type",
      component: batch_processes,
      meta: { title: "Procesos batch", requires: ["batch.view_all"] },
    },
  ],
  linkActiveClass: "active",
});

function checkIsGlobalUser() {
  const profileVal = typeof auth.user.profile === 'object'
    ? (auth.user.profile ? auth.user.profile.profile : null)
    : auth.user.profile;
  const domainVal = typeof auth.user.profile === 'object' && auth.user.profile
    ? auth.user.profile.domain
    : null;
  return domainVal === 'global' || ['GlobalViewer', 'AuditorGlobal', 'GLOBAL_VIEWER'].includes(profileVal);
}

router.beforeEach((to, from, next) => {
  if (
    !auth.user.authenticated &&
    to.path != "/login" &&
    to.path != "/notfound"
  ) {
    auth.checkUser()
      .then(() => {
        const isGlobal = checkIsGlobalUser();

        if (isGlobal) {
          if (to.path === '/' || to.path === '/dashboard' || (to.path !== '/reports/globalheadcount' && to.path !== '/tutorials')) {
            return next('/reports/globalheadcount');
          }
        } else {
          if (to.path === '/reports/globalheadcount') {
            return next('/notfound');
          }
        }

        if (to.meta["requires"] !== undefined && !auth.can(to.meta["requires"])) {
          return next("/notfound");
        }

        if (to.path != "/login" && to.path != "/notfound") {
          localStorage.setItem("path_after_login", to.fullPath);
        }
        next();
      })
      .catch(() => {
        if (to.path !== "/login") {
          next('/login');
        } else {
          next();
        }
      });
  } else {
    const isGlobal = checkIsGlobalUser();

    if (isGlobal) {
      if (to.path === '/' || to.path === '/dashboard' || (to.path !== '/reports/globalheadcount' && to.path !== '/tutorials')) {
        return next('/reports/globalheadcount');
      }
    } else {
      if (to.path === '/reports/globalheadcount') {
        return next('/notfound');
      }
    }

    if (to.meta["requires"] !== undefined && !auth.can(to.meta["requires"])) {
      next("/notfound");
    } else {
      if (to.path != "/login" && to.path != "/notfound") {
        localStorage.setItem("path_after_login", to.fullPath);
      }
      next();
    }
  }
});

let isAlertPopupOpen = false;

window.checkAndDisplayAlerts = function() {
  const token = localStorage.getItem("id_token");
  if (!token || isAlertPopupOpen) return;

  const isGlobal = checkIsGlobalUser();
  if (isGlobal) {
    return;
  }

  axios.get('/api/alerts/check')
    .then(response => {
      const alertList = response.data.alerts || [];
      if (alertList.length > 0) {
        displayAlertPopupsSequentially(alertList, 0);
      }
    })
    .catch(() => {});
};

function displayAlertPopupsSequentially(alertList, index) {
  if (index >= alertList.length) {
    isAlertPopupOpen = false;
    return;
  }

  isAlertPopupOpen = true;
  const alertItem = alertList[index];

  // Icons and Theme Colors per type
  let popupIcon = 'warning';
  let themeColor = '#e6a23c';

  if (alertItem.type === 'unassigned_current_week') {
    popupIcon = 'error';
    themeColor = '#f56c6c';
  } else if (alertItem.type === 'unassigned_days') {
    popupIcon = 'info';
    themeColor = '#409EFF';
  } else if (alertItem.type === 'unassigned_next_week') {
    popupIcon = 'warning';
    themeColor = '#e6a23c';
  }

  let contentHtml = `<p style="text-align: left; margin-bottom: 10px; font-size: 14px; color: #303133;"><strong>${alertItem.message}</strong></p>`;
  contentHtml += `<p style="text-align: left; color: #606266; font-size: 13px; margin-bottom: 8px;"><strong>Período Afectado:</strong> ${alertItem.period}</p>`;

  if (alertItem.affected_employees && alertItem.affected_employees.length > 0) {
    if (alertItem.type === 'unassigned_days') {
      contentHtml += `
        <div style="max-height: 220px; overflow-y: auto; text-align: left; border: 1px solid #ebeef5; border-radius: 6px; padding: 8px; margin-top: 10px;">
          <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
            <thead>
              <tr style="background: #f5f7fa; text-align: left; color: #303133;">
                <th style="padding: 6px; border-bottom: 2px solid #e4e7ed;">Empleado</th>
                <th style="padding: 6px; border-bottom: 2px solid #e4e7ed;">Área Funcional</th>
                <th style="padding: 6px; border-bottom: 2px solid #e4e7ed;">Días Sin Turno</th>
              </tr>
            </thead>
            <tbody>
              ${alertItem.affected_employees.map(emp => `
                <tr>
                  <td style="padding: 6px; border-bottom: 1px solid #ebeef5;"><strong>${emp.name}</strong> (${emp.id_number})</td>
                  <td style="padding: 6px; border-bottom: 1px solid #ebeef5; color: #909399;">${emp.area_name || 'Sin Área'}</td>
                  <td style="padding: 6px; border-bottom: 1px solid #ebeef5; color: ${themeColor}; font-weight: bold;">${emp.unassigned_dates.join(', ')}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        </div>
      `;
    } else {
      contentHtml += `
        <div style="max-height: 200px; overflow-y: auto; text-align: left; border: 1px solid #ebeef5; border-radius: 6px; padding: 10px; margin-top: 10px;">
          <p style="margin: 0 0 6px 0; font-size: 13px; color: ${themeColor};"><strong>${alertItem.unassigned_count} empleado(s) sin asignación en tus áreas:</strong></p>
          <ul style="margin: 0; padding-left: 20px; font-size: 13px; color: #606266;">
            ${alertItem.affected_employees.map(emp => `<li style="margin-bottom: 4px;"><strong>${emp.name}</strong> (C.C. ${emp.id_number}) - <span style="color: #909399;">${emp.area_name || 'Sin Área'}</span></li>`).join('')}
          </ul>
        </div>
      `;
    }
  }

  Swal.fire({
    icon: popupIcon,
    title: alertItem.title,
    html: contentHtml,
    confirmButtonText: (index < alertList.length - 1) ? 'Siguiente Alerta' : 'Entendido',
    confirmButtonColor: themeColor,
    allowOutsideClick: false,
  }).then(() => {
    displayAlertPopupsSequentially(alertList, index + 1);
  });
}

router.afterEach((to, from) => {
  if (to.path !== '/login' && to.path !== '/notfound') {
    setTimeout(() => {
      if (window.checkAndDisplayAlerts) {
        window.checkAndDisplayAlerts();
      }
    }, 600);
  }
});

// router.beforeEach((to, from, next) => {
//     if (!auth.user.authenticated && to.path != '/login' && to.path != '/notfound') {
//         localStorage.setItem('path_after_login', to.fullPath);
//         auth.checkUser().then(() => {
//             next(to.fullPath);
//         });
//     } else {
//         if (to.meta['requires'] !== undefined && !auth.can(to.meta['requires'])) {
//                 // console.log('forbiden path');
//             next('/notfound');
//         } else {
//             next();
//         }
//     }
// });

axios.interceptors.response.use(
  (response) => {
    // intercept the global error
    // console.log(response.headers);
    if (response.headers.authorization != undefined) {
      window.axios.defaults.headers.common["Authorization"] =
        response.headers.authorization;
      localStorage.setItem(
        "id_token",
        response.headers.authorization.substr(7)
      );
      // } else {
      //     window.axios.defaults.headers.common['Authorization'] = null;
      //     localStorage.setItem('id_token', null);
    }
    clearTimeout(openTimeCounter);
    openTimeCounter = setTimeout(app.openTimeAlert, 1000 * 60 * 115);
    // openTimeCounter = setTimeout(app.openTimeAlert, 1000 * 5);
    app.timeAlertVisible = false;
    return response;
  },
  function(error) {
    if (!error || !error.response) {
      return Promise.reject(error);
    }
    let originalRequest = error.config;
    if (error.response.status === 401 || error.response.status === 400) {
      auth.user.authenticated = false;
      if (router.currentRoute && router.currentRoute.path !== '/login') {
        router.push("/login");
      }
    }
    if (error.response.headers && error.response.headers.authorization != undefined) {
      window.axios.defaults.headers.common["Authorization"] =
        error.response.headers.authorization;
      localStorage.setItem(
        "id_token",
        error.response.headers.authorization.substr(7)
      );
    }
    if (error.response.status === 404) {
      originalRequest._retry = true;
      if (router.currentRoute && router.currentRoute.path !== '/notfound') {
        router.push("/notfound");
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// console.log(auth);

let openTimeCounter;
let timeLeftInterval;

const timeLeft = 300;
// const timeLeft = 10;

const app = new Vue({
  store,
  data: {
    auth,
    title: null,
    loading: false,
    timeLeft,
    minLeft: null,
    timeAlertVisible: false,
    message: null,
  },
  router,
  //   vuetify,
  updated: function() {
    this.title = this._route.meta.title;
  },
  methods: {
    openTimeAlert: function() {
      this.timeLeft = timeLeft;
      this.minLeft =
        Math.floor(this.timeLeft / 60)
          .toString()
          .padStart(2, "0") +
        ":" +
        (this.timeLeft % 60).toString().padStart(2, "0");
      this.timeAlertVisible = true;
      timeLeftInterval = window.setInterval(this.tick, 1000);
    },
    closeTimeAlert: function() {
      this.timeAlertVisible = false;
      window.clearInterval(timeLeftInterval);
    },
    tick: function() {
      this.timeLeft--;
      this.minLeft =
        Math.floor(this.timeLeft / 60)
          .toString()
          .padStart(2, "0") +
        ":" +
        (this.timeLeft % 60).toString().padStart(2, "0");
      if (this.timeLeft > 0) {
        return false;
      }
      this.closeSession();
    },
    closeSession: function() {
      this.timeAlertVisible = false;
      window.clearInterval(timeLeftInterval);
      this.$auth.signout(this);
      // this.timeLeft = timeLeft;
    },
    extendSession: function() {
      this.timeAlertVisible = false;
      window.clearInterval(timeLeftInterval);
      this.$auth.checkUser();
      // this.timeLeft = timeLeft;
    },
  },
}).$mount("#app");
